import { createSlice } from '@reduxjs/toolkit'

export const initialData = {
    data: {},
    show:false,
    loading: false,
    list: [],
    index: []
}

const priceDrawerNewSlice = createSlice({
    name: 'priceDrawerNew',
    initialState: {...initialData },
    reducers: {
        updateDrawer: (state, action) => {
            state.data = { ...action.payload }
        },
        closeDrawer: (state) => {
            state.show = false
        },
        openDrawer: (state) => {
            state.show = true
        },
        updateList: (state, action) => {
            const seenIds = new Set()
            const dir = []
            action.payload.forEach((item) => {
                if (!seenIds.has(item.id)) {
                    seenIds.add(item.id)
                    dir.push(item.id)
                }
            })
            state.index = dir
            state.list = action.payload
        }
    },
    extraReducers: {
       /* [updateDrawer.fulfilled]: (state, action) => {
            state.loading = false
        },
        [updateDrawer.pending]: (state) => {
            state.loading = true
        },*/
    }
})

export const { updateDrawer, openDrawer, closeDrawer, updateList } = priceDrawerNewSlice.actions

export default priceDrawerNewSlice.reducer